import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { BsMouse } from "react-icons/bs";
import { ImLinkedin } from "react-icons/im";
import { FaGithub } from "react-icons/fa";
import { AiOutlineArrowDown, AiOutlineDownload } from "react-icons/ai";
import Ajay_Resume from "./Ajay_Resume.pdf";
import Aos from "aos";
import "aos/dist/aos.css";
import Typed from "react-typed";

const Home = () => {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <Box id="home" Width={"100vw"} marginLeft={{ base: "20px" }}>
      <Flex
        height={{ base: "80vh", lg: "100vh" }}
        maxHeight={"750px"}
        className="background"
        flexDir={{ base: "column-reverse", lg: "row" }}
        align={"center"}
        justify="center"
        gap={{ base: "4", md: "6", lg: "8" }}
        marginBottom={["40px", "0px", "0px"]}
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
      >
        <Flex
          maxWidth={{ base: "100%", lg: "40%" }}
          flexDir="column"
          gap="1rem"
          padding={"5px"}
        >
          <Flex gap="0.6rem">
            <Heading id="user-detail-name">Hi, I am </Heading>
            <Heading color={"teal"}> Ajay</Heading>
          </Flex>

          <Box>
            <Text fontSize={"2rem"} fontWeight={"bolder"} color={"teal"}>
              <Typed
                strings={[
                  "A Tech-Enthusiast",
                  "A MERN Stack Developer",
                  "A Full-Stack Developer",
                  "A Prompt Engineer",
                  "An Open-Source Contributor",
                ]}
                typeSpeed={100}
                backSpeed={20}
                loop
              ></Typed>
            </Text>
          </Box>

          <Text>
            A Full Stack Developer Skilled in MERN stack with hands-on
            experience in developing scalable websites using a wide range of
            Front-end and Back-end skills like HTML, CSS, JavaScript, React,
            Redux, MongoDB, and Node JS. Looking forward to joining a
            progressive organization with opportunities to work on challenging
            projects.
          </Text>
          <Flex gap={"8"} align="center">
            <Button
              width="max-content"
              colorScheme={"teal"}
              id="resume-button-2"
              onClick={() => {
                window.open(
                  "https://drive.google.com/file/d/1FaGp-WVtNALfsCMVjZESGzTDR6q3SpRf/view?usp=drive_link",
                  "_blank"
                );
              }}
            >
              <a
                id="resume-link-2"
                href={Ajay_Resume}
                target="_blank"
                rel="noreferrer"
                download="Ajay_Resume.pdf"
              >
                Resume
              </a>
              <Text as="span" ml={"2"}>
                <AiOutlineDownload fontSize={"1.2rem"} />
              </Text>
            </Button>

            <Flex gap="3">
              <Link
                id="contact-linkedin"
                href="https://www.linkedin.com/in/ajay-84sia"
                isExternal
              >
                <ImLinkedin fontSize={"1.6rem"} />
              </Link>
              <Link
                id="contact-github"
                href="https://github.com/Ajay84sia"
                isExternal
              >
                <FaGithub fontSize={"1.6rem"} />
              </Link>
            </Flex>
          </Flex>
          <Box marginTop={"4rem"} display={{ base: "none", lg: "block" }}>
            <Link href="#about">
              <Flex align={"center"} gap="2">
                <span>
                  <BsMouse fontSize={"1.4rem"} />
                </span>
                <Text>scroll down</Text>
                <span>
                  <AiOutlineArrowDown />
                </span>
              </Flex>
            </Link>
          </Box>
        </Flex>
        <Box
          height={{ base: "200px", md: "300px", lg: "400px" }}
          overflow="hidden"
          className="profile"
        >
          <Image
            src="https://media.giphy.com/media/L8K62iTDkzGX6/giphy.gif"
            borderRadius="1.2rem"
            height="100%"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
